<template>
	<div class="home">
		
		<div class="ProductList height2">
			<ProductList :typeName="typeName"></ProductList>
			
			
		</div>

		<FootTab></FootTab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import ProductList from "@/components/ProductList.vue";
	import FootTab from "@/components/FootTab.vue";
	export default {
		name: "productFilter",
		components: {
			FootTab,
			ProductList
		},
		data() {
			return {
				"hasHead": false,
				"typeName": '离我最近',

				classifyArr: [{
					"name": "美食餐饮"
				}, {
					"name": "休闲娱乐"
				}, {
					"name": "丽人美发"
				}, {
					"name": "生活服务"
				}, {
					"name": "亲子玩乐"
				}, {
					"name": "酒店门票"
				}, {
					"name": "享吃龙虾"
				}, {
					"name": "品牌优选"
				}],

				"isRouterAlive": true
			}
		},
		activated() {

		},
		created() {

		},
		mounted() {
			var that = this;
			
			if (that.$route.query.hasHead == 'false') {
				that.hasHead = false;
			} else{
				that.hasHead = true;
			}
		},
		methods: {
			defImg() { // 图片加载失败时加载占位图
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			
		}

	};
</script>

<style scoped lang="scss">
	.home {
		height: 100vh;
		overflow: auto;
		padding-bottom: 1.6rem;
		padding-top: 0.3rem;

		.head::-webkit-scrollbar {
			display: none;
			/* Chrome Safari */
		}

		.head {
			white-space: nowrap;
			width: 100%;
			overflow-x: auto;
			scrollbar-width: none;
			/* firefox */
			-ms-overflow-style: none;
			/* IE 10+ */
			padding: 0rem 0rem 0.3rem 0.3rem;

			li {
				display: inline-block;
				vertical-align: middle;
				color: #ff6600;
				font-size: 0.3rem;
				font-weight: bold;
				margin-right: 0.5rem;
			}
		}

		.ProductList {
			padding: 0px 0.2rem 0px 0.3rem;
		}


		.ProductList.height1 {
			height: calc(100vh - 1.7rem);
		}

		.ProductList.height2 {
			height: calc(100vh - 1.7rem);
		}

	}
</style>
